"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORIES_SET_CATEGORY_GROUPS = exports.CATEGORIES_RESET_DATA = exports.CATEGORIES_SET_CATEGORIES = void 0;
const const_1 = require("../../const");
exports.CATEGORIES_SET_CATEGORIES = `${const_1.PREFIX_ENRICH}CATEGORIES_SET_CATEGORIES`;
exports.CATEGORIES_RESET_DATA = `${const_1.PREFIX_ENRICH}CATEGORIES_RESET_DATA`;
exports.CATEGORIES_SET_CATEGORY_GROUPS = `${const_1.PREFIX_ENRICH}CATEGORIES_SET_CATEGORY_GROUPS`;
